/**
 * Frontend debug logger that sends logs to backend file
 */

import { API_CONFIG } from '../services/api/endpoints';

const DEBUG_ENABLED = true;

export async function logToFile(message: string, data?: any) {
  if (!DEBUG_ENABLED) return;
  
  // Also log to console
  
  try {
    await fetch(`${API_CONFIG.BASE_URL}/debug/log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        message, 
        data: data ? JSON.stringify(data, null, 2) : undefined 
      })
    });
  } catch (error) {
    // Silently fail - don't break app if logging fails
  }
}
